module.exports = __webpack_public_path__ + "img/left-image.1a0c9db0.png";